import { Setting } from '../utility/Setting';

/**
 * イントロアニメーション
 */
export class Intro {
  /**
   * イントロをスキップするトリガー要素
   */
  private readonly $skip: JQuery;

  /**
   * 実行するイントロパートのリスト
   */
  private readonly introPartList: IntroPart[] = [];

  /**
   * スキップされたかの真偽値
   */
  private isSkip: boolean = false;

  /**
   * コンストラクタ
   * @param skipSelector イントロをスキップするトリガーセレクタ
   * @param introPartList 実行するイントロパートのリスト
   * @param isUseSP SPで使用するかの真偽値
   * @param isFixed 画面固定するかの真偽値
   */
  constructor(skipSelector: string, introPartList: IntroPart[], isUseSP: boolean = false, isFixed: boolean = true) {
    this.$skip = $(skipSelector);

    if ((! isUseSP && Setting.isSp()) || ! this.$skip[0]) {
      return;
    }

    for (let introPart of introPartList) {
      this.introPartList.push(introPart);
    }

    if (isFixed) {
      this.introPartList.push({
        delay: 0,
        stay: 0,
        callable: (): void => {
          this.$skip.off('click', this.skip);
          $('body').css('overflow', 'visible');
        }
      });
    }

    $('html, body').animate({scrollTop: 0}, 0, (): void => {
      if (isFixed) {
        $('body').css('overflow', 'hidden');
      }
    });

    $(window).on('load', (): void => {
      if ((! isUseSP && Setting.isSp()) || ! $(skipSelector)[0]) {
        return;
      }

      this.run();
    });
  }

  /**
   * イントロ実行
   */
  private async run(): Promise<void> {
    this.$skip.on('click', this.skip);

    for (let introPart of this.introPartList) {
      await ((): Promise<any> => {
        return new Promise((resolve: any, reject: any): void => {
          setTimeout((): void => {
            if (! this.isSkip) {
              introPart.callable();
            }

            setTimeout((): void => {
              resolve();
            }, introPart.stay);
          }, introPart.delay);
        });
      })();
    }
  }

  /**
   * イントロスキップ
   */
  public skip = (): void => {
    this.$skip.off('click', this.skip);
    this.isSkip = true;

    for (let introPart of this.introPartList) {
      introPart.callable();
    }
  }
}

/**
 * イントロパート
 */
export interface IntroPart {
  /**
   * 遅延時間（ミリ）
   */
  delay: number;

  /**
   * 滞在時間（ミリ）
   */
  stay: number;

  /**
   * 実行関数
   */
  callable: () => void;
}
